export const companyType = [
  'Persona Natural',
  'Persona Jurídica',
  'Grupo Solidario',
  'Banco Comunal',
  'Asociación Comunitaria',
  'Entidades Concesionarias de Servicios Municipales',
  'Asociaciones Proveedoras de Servicios Básicos',
  'Asociaciones Civiles Organizadas para Beneficio Municipal',
  'Instituciones Financieras',
]

export const getListCountry = () => {
  return [
    'Panamá',
    'Guatemala',
    'Honduras',
    'El Salvador',
    'Nicaragua',
    'Costa Rica',
    'República Dominicana',
  ]
}

export const getListCountryWithCode = () => {
  return [
    { id: 1, abr: 'CRI', country: 'Costa Rica' },
    { id: 2, abr: 'GTM', country: 'Guatemala' },
    { id: 3, abr: 'HDN', country: 'Honduras' },
    { id: 4, abr: 'NIC', country: 'Nicaragua' },
    { id: 5, abr: 'SLV', country: 'El Salvador' },
    { id: 6, abr: 'PAN', country: 'Panamá' },
    { id: 7, abr: 'DOM', country: 'República Dominica' },
  ]
}

/* export const getListStatesWithCode = () => {
  return [
    { id: 1, value: 'En proceso MiPyme' },
    { id: 2, value: 'En proceso IFI' },
    { id: 3, value: 'Pre-Elegible' },
    { id: 4, value: 'No Pre-Elegible' },
    { id: 5, value: 'En revisión ' },
    { id: 6, value: 'Retornado MiPyme' },
    { id: 7, value: 'Retornado IFI' },
  ]
} */

export const getListStatesWithCode = () => {
  return [
    //  { id: 1, value: 'En proceso MiPyme' },
    //  { id: 2, value: 'En proceso IFI' },
    { id: 3, value: 'Pre-Elegible' },
    { id: 4, value: 'No Pre-Elegible' },
    { id: 5, value: 'En revisión ' },
    //  { id: 6, value: 'Retornado MiPyme' },
    //  { id: 7, value: 'Retornado IFI' },
  ]
}

export const getListStatesDraftWithCode = () => {
  return [
    { id: 1, value: 'En proceso' },
    // { id: 2, value: 'En proceso IFI' },
    { id: 6, value: 'Retornado' },
    // { id: 7, value: 'Retornado IFI' },
  ]
}

export const getAlphabeticalOrders = () => {
  return ['Orden Ascendente', 'Orden Descendente']
}

export const getFormStates = () => {
  return [
    'En proceso MiPyme',
    'En proceso IFI',
    'Pre-Elegible',
    'No Pre-Elegible',
  ]
}

export const currencyType = [
  {
    shortName: 'HNL',
    LargeName: 'Honduras',
    moneda: 'Lempira',
  },
  {
    shortName: 'NIC',
    LargeName: 'Nicaragua',
    moneda: 'Córdobas',
  },
  {
    shortName: 'SLV',
    LargeName: 'El Salvador',
    moneda: 'Dólares',
  },
  {
    shortName: 'CRC',
    LargeName: 'Costa Rica',
    moneda: 'Colones Costarricenses',
  },
  {
    shortName: 'GTQ',
    LargeName: 'Guatemala',
    moneda: 'Quetzales',
  },
  {
    shortName: 'DOP',
    LargeName: 'República Dominicana',
    moneda: 'Peso Dominicano',
  },
  {
    shortName: 'PAN',
    LargeName: 'Panamá',
    moneda: 'Balboa Panameño',
  },
]

export const genero = ['Femenino', 'Masculino']

export const getCurrencyByCountry = (country) => {
  switch (country) {
    case 'Panamá' || 'Panama':
      return ['Balboa Panameño', 'Dólares']
    case 'Guatemala':
      return ['Quetzales', 'Dólares']
    case 'Honduras':
      return ['Lempiras', 'Dólares']
    case 'El Salvador':
      return ['Dólares']
    case 'Nicaragua':
      return ['Córdobas', 'Dólares']
    case 'Costa Rica':
      return ['Colones Costarricenses', 'Dólares']
    case 'República Dominicana ':
      return ['Peso Dominicano', 'Dólares']
    default:
      return ['Dólares']
  }
}

export const getCurrencyCode = (currency) => {
  switch (currency) {
    case 'Balboa Panameño':
      return 'PAB'
    case 'Quetzales':
      return 'GTQ'
    case 'Lempiras':
      return 'HNL'
    case 'Córdobas':
      return 'NIC'
    case 'Colones Costarricenses':
      return 'CRC'
    case 'Peso Dominicano':
      return 'DOP'
    default:
      return null
  }
}

export const getProvincesByCountry = (country) => {
  switch (country) {
    case 'Panamá' || 'Panama':
      return [
        'Bocas del Toro',
        'Coclé',
        'Colón',
        'Chiriquí',
        'Darién',
        'Herrera',
        'Los Santos',
        'Panamá',
        'Veraguas',
        'Panamá Oeste',
      ]
    case 'Guatemala':
      return [
        'Alta Verapaz',
        'Baja Verapaz',
        'Chimaltenango',
        'Chiquimula',
        'Guatemala',
        'El Progreso',
        'Escuintla',
        'Huehuetenango',
        'Izabal',
        'Jalapa',
        'Jutiapa',
        'Petén',
        'Quetzaltenango',
        'Quiché',
        'Retalhuleu',
        'Sacatepéquez',
        'San Marcos',
        'Santa Rosa',
        'Sololá',
        'Suchitepéquez',
        'Zacapa',
        'Totonicapán',
      ]
    case 'Honduras':
      return [
        'Francisco Morazán',
        'Atlántida',
        'Choluteca',
        'Colón',
        'Comayagua',
        'Copán',
        'Cortés',
        'El Paraíso',
        'Gracias a Dios',
        'Intibucá',
        'La Paz',
        'Lempira',
        'Ocotepeque',
        'Olancho',
        'Santa Bárbara',
        'Valle',
        'Yoro',
      ]
    case 'El Salvador':
      return [
        'Ahuachapán',
        'Santa Ana',
        'Sonsonate',
        'Usulután',
        'San Miguel',
        'Morazán',
        'La Unión',
        'La Libertad',
        'Chalatenango',
        'Cuscatlán',
        'San Salvador',
        'La Paz',
        'Cabañas',
        'San Vicente',
      ]
    case 'Nicaragua':
      return [
        'Atlántico Norte',
        'Atlántico Sur',
        'Boaco',
        'Carazo',
        'Chinandega',
        'Chontales',
        'Estelí',
        'Granada',
        'Jinotega',
        'León',
        'Madriz',
        'Managua',
        'Masaya',
        'Matagalpa',
        'Nueva Segovia',
        'Río San Juan',
        'Rivas',
      ]
    case 'Costa Rica':
      return [
        'San José',
        'Alajuela',
        'Cartago',
        'Guanacaste',
        'Heredia',
        'Limón',
        'Puntarenas',
      ]
    case 'República Dominicana ':
      return [
        'Azúa',
        'Baoruco',
        'Barahona',
        'Dajabón',
        'Distrito Nacional',
        'Duarte',
        'Elías Pina',
        'El Seibo',
        'Espaillat',
        'Hato Mayor',
        'Independencia',
        'La Altagracia',
        'La Romana',
        'La Vega',
        'Maria Trinidad Sanchez',
        'Monseñor Nouel',
        'Monte Cristi',
        'Monte Plata',
        'Pedernales',
        'Peravia',
        'Puerto Plata',
        'Salcedo',
        'Samana',
        'Sánchez Ramírez',
        'San Cristóbal',
        'San Jose de Ocoa',
        'San Juan',
        'San Pedro de Macorís',
        'Santiago',
        'Santiago Rodríguez',
        'Santo Domingo',
        'Valverde',
      ]
    default:
      return null
  }
}

export const getProductivesSectorsByCountry = (country) => {
  switch (country) {
    case 'Panamá' || 'Panama':
      return {
        productiveSector: [
          'Agricultura orgánica o agroecológica',
          'Turismo Sostenible',
          'Manejo Forestal Sostenible',
          'Actividades productivas en áreas protegidas privadas / comunitarias',
        ],
        activity: [
          ['Micro riegos'],
          [
            'Zoocriaderos de especies de vida silvestre',
            'Hundimiento de barcos con fines ecoturísticos',
            'Construcción de terminales para transporte terrestre de pasajeros y carga que incluye locales comerciales',
            'Construcción de terminales para transporte terrestre de pasajeros y carga',
            'Construcción, ampliación y reparación de muelles con o sin obras conexas terrestre',
            'Construcción de estaciones ferroviarias',
            'Construcción y operación de hoteles, albergues, complejos turísticos y clubes campestres',
            'Parques de diversiones permanentes (juegos acuáticos y terrestres), que incluye restaurante, tiendas de conveniencia, entre otro',
            'Mantenimiento rutinario de carreteras',
            'Mantenimiento periódico de carreteras',
            'Caminos rurales',
            'Mejoramiento y ampliación de micro proyectos: edificaciones de hasta nueve pisos',
            'Equipamiento de instalaciones para telecomunicaciones',
            'Equipamiento de puertos o aeropuertos',
          ],
          [
            'Aserraderos',
            'Extracción y traslado de hasta 500 plantas de especies de bosque nativo, como planta viva y para fines ornamentales, especies no amenazadas ni en peligro de extinción o a más de 10 individuos por hectárea',
          ],
          [
            'Proyecto intensivo de ganadería bovina que incluye planta de transformación de la leche y rastro',
            'Generación de energía hídrica',
            'Generación de energía eólica',
            'Generación de energía solar',
            'MicroRedes eléctricas fotovoltaicas',
            'Construcción de mercados, centros de acopio para almacenamiento y distribución de alimentos y bebidas',
            'Instalación de sistemas de generación de energía mediante cogeneración y/o ciclo combinado en plantas existentes generadoras.',
            'Proyectos de eficiencia energética: iluminación, sustitución de equipos existentes por eficientes',
          ],
        ],
      }
    case 'Honduras':
      return {
        productiveSector: [
          'Agricultura orgánica o agroecológica',
          'Turismo Sostenible',
          'Manejo Forestal Sostenible',
          'Actividades productivas en áreas protegidas privadas / comunitarias',
        ],
        activity: [
          ['Micro riegos'],
          [
            'Zoocriaderos de especies de vida silvestre',
            'Hundimiento de barcos con fines ecoturísticos',
            'Construcción de terminales para transporte terrestre de pasajeros y carga que incluye locales comerciales',
            'Construcción de terminales para transporte terrestre de pasajeros y carga',
            'Construcción, ampliación y reparación de muelles con o sin obras conexas terrestre',
            'Construcción de estaciones ferroviarias',
            'Construcción y operación de hoteles, albergues, complejos turísticos y clubes campestres',
            'Parques de diversiones permanentes (juegos acuáticos y terrestres), que incluye restaurante, tiendas de conveniencia, entre otro',
            'Mantenimiento rutinario de carreteras',
            'Mantenimiento periódico de carreteras',
            'Caminos rurales',
            'Mejoramiento y ampliación de micro proyectos: edificaciones de hasta nueve pisos',
            'Equipamiento de instalaciones para telecomunicaciones',
            'Equipamiento de puertos o aeropuertos',
          ],
          [
            'Aserraderos',
            'Extracción y traslado de hasta 500 plantas de especies de bosque nativo, como planta viva y para fines ornamentales, especies no amenazadas ni en peligro de extinción o a más de 10 individuos por hectárea',
          ],
          [
            'Proyecto intensivo de ganadería bovina que incluye planta de transformación de la leche y rastro',
            'Generación de energía hídrica',
            'Generación de energía eólica',
            'Generación de energía solar',
            'MicroRedes eléctricas fotovoltaicas',
            'Construcción de mercados, centros de acopio para almacenamiento y distribución de alimentos y bebidas',
            'Instalación de sistemas de generación de energía mediante cogeneración y/o ciclo combinado en plantas existentes generadoras.',
            'Proyectos de eficiencia energética: iluminación, sustitución de equipos existentes por eficientes',
          ],
        ],
      }
    case 'Nicaragua':
      return {
        productiveSector: [
          'Agricultura orgánica o agroecológica',
          'Turismo Sostenible',
          'Manejo Forestal Sostenible',
          'Actividades productivas en áreas protegidas privadas / comunitarias',
        ],
        activity: [
          ['Micro riegos'],
          [
            'Zoocriaderos de especies de vida silvestre',
            'Hundimiento de barcos con fines ecoturísticos',
            'Construcción de terminales para transporte terrestre de pasajeros y carga que incluye locales comerciales',
            'Construcción de terminales para transporte terrestre de pasajeros y carga',
            'Construcción, ampliación y reparación de muelles con o sin obras conexas terrestre',
            'Construcción de estaciones ferroviarias',
            'Construcción y operación de hoteles, albergues, complejos turísticos y clubes campestres',
            'Parques de diversiones permanentes (juegos acuáticos y terrestres), que incluye restaurante, tiendas de conveniencia, entre otro',
            'Mantenimiento rutinario de carreteras',
            'Mantenimiento periódico de carreteras',
            'Caminos rurales',
            'Mejoramiento y ampliación de micro proyectos: edificaciones de hasta nueve pisos',
            'Equipamiento de instalaciones para telecomunicaciones',
            'Equipamiento de puertos o aeropuertos',
          ],
          [
            'Aserraderos',
            'Extracción y traslado de hasta 500 plantas de especies de bosque nativo, como planta viva y para fines ornamentales, especies no amenazadas ni en peligro de extinción o a más de 10 individuos por hectárea',
          ],
          [
            'Proyecto intensivo de ganadería bovina que incluye planta de transformación de la leche y rastro',
            'Generación de energía hídrica',
            'Generación de energía eólica',
            'Generación de energía solar',
            'MicroRedes eléctricas fotovoltaicas',
            'Construcción de mercados, centros de acopio para almacenamiento y distribución de alimentos y bebidas',
            'Instalación de sistemas de generación de energía mediante cogeneración y/o ciclo combinado en plantas existentes generadoras.',
            'Proyectos de eficiencia energética: iluminación, sustitución de equipos existentes por eficientes',
          ],
        ],
      }
    default:
      return []
  }
}

export const getClimateThreat = () => {
  return [
    'Sequía',
    'Inundaciones Causadas por Lluvias Intensas',
    'Tormentas',
    'Olas de Calor',
    'Huracanes',
    'Heladas',
    'Granizo',
    'Modificación de las Fechas de Siembra y Cosecha',
    'Plagas',
    'Incendios Forestales',
    'Aumento del Nivel del Mar',
    'Otros Peligros Identificados',
  ]
}

export const getAdaptationActions = () => {
  return [
    'Manejo del Agua',
    'Riego Eficiente',
    'Conservación y Protección del Suelo',
    'Variedades Resistentes',
    'Mejora de los Sistemas de Pastoreo/Calendario',
    'Sistemas Agroforestales/Silvopastoriles',
    'Buenas Prácticas Agrícolas',
    'Postcosecha',
    'Diversificación',
    'Reforestación para la Protección',
    'Uso de Fertilizantes Orgánicos',
    'Sistemas de Producción Agroecológica',
    'Bosques de Galería para la Prevención de Inundaciones',
    'Control Biológico de Plagas y Enfermedades',
    'Medidas Basadas en la Biodiversidad',
    'Manejo Resiliente (general)',
    'Redes Antigranizo',
    'Certificación Agroecológica',
    'Trabajo de Prevención de Incendios Forestales',
    'Agricultura de Contorno',
    'Infraestructura Resiliente a Eventos Extremos',
    'Otros',
  ]
}

export const getLineOfBusiness = () => {
  return [
    'Producción o Actividades que impliquen alguna forma de Trabajo Forzoso o Trata de Personas',
    'Producción, Comercio o Elaboración de Drogas o Sustancias Psicotrópicas consideradas Ilegales',
    'Producción o Comercio de Armas y Municiones u otras Actividades relacionadas con la Industria Bélica',
    'Tabaco',
    'Juegos de Azar, Casinos o Empresas Equivalentes',
    'Producción o Comercio de Materiales Radiactivos',
    'Producción o Comercio de Fibras de Asbestos No Protegidas o Uso de éstas',
    'Traslado de Desechos Transfronterizo',
    'Redes de Arrastre en Ambiente Marino con Redes Mayores a 2.5 Km de Largo',
    'Minería',
    'Ninguno de los anteriores',
  ]
}

export const getQuestionActivity = (activity) => {
  switch (activity) {
    case 'Hundimiento de barcos con fines ecoturísticos':
      return {
        has: true,
        type: 'checkbox',
        description: '¿Utilizan fondo marino?',
      }
    case 'Generación de energía hídrica':
      return { has: true, type: 'text', description: 'Cantidad de Megavatios' }
    case 'Generación de energía eólica':
      return { has: true, type: 'text', description: 'Cantidad de Hectareas' }
    case 'Generación de energía solar':
      return { has: true, type: 'text', description: 'Cantidad de Hectareas' }
    case 'MicroRedes eléctricas fotovoltaicas':
      return { has: true, type: 'text', description: 'Cantidad de Hectareas' }
    case 'Proyecto intensivo de ganadería bovina que incluye planta de transformación de la leche y rastro':
      return {
        has: true,
        type: 'checkbox',
        description: '¿Se utilizan Rastros y/o centros de acopio de leche?',
      }
    case 'Aserraderos':
      return {
        has: true,
        type: 'checkbox',
        description: '¿Se utilizan Aserraderos Moviles?',
      }
    default:
      return null
  }
}

export const getGeneros = () => {
  return [
    { idGenero: 1, description: 'Femenino' },
    { idGenero: 2, description: 'Masculino' },
  ]
}
